import { render } from "./backgroundComponent.vue?vue&type=template&id=4904f4a8&scoped=true"
import script from "./backgroundComponent.vue?vue&type=script&lang=js"
export * from "./backgroundComponent.vue?vue&type=script&lang=js"

import "./backgroundComponent.vue?vue&type=style&index=0&id=4904f4a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4904f4a8"]])

export default __exports__